export default {
  QUEUE: 'queue',
  APPROVED: 'approved'
};
